import axios from "@/plugins/axios";

export function queryByName(data){
    return axios.post('/out/datalist/queryByName',data)
}

export function getDatalist(data) {
    return axios.post('/out/datalist/page',data)
}

export function addVisitor(data){
    return axios.post('/out/visitor',data)
}

export function getVisitor(data){
    return axios.get('/out/visitor',data)
}

export function getDashboard(){
    return axios.get('/dashboard')
}